import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalType } from 'src/shared/enums';

import { HeaderErrorEnum } from '../../shared/enums/header-error.enum';
import { IReqIdentifier } from '../../shared/interfaces/req-identifier';
import { SetError } from '../../shared/store/actions/errors.action';
import { errorCodeTranslator, errorMessageTranslator } from '../../shared/utils/error-translator.utils';
import { ModalService } from './../../shared/services/internal/modal.service';
import { Logout } from './../../shared/store/actions/auth.action';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private ownErrorRequests: IReqIdentifier[];

    constructor(private store: Store, private modalService: ModalService, private actions$: Actions) {
        this.ownErrorRequests = [];
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let requestToHandle: HttpRequest<any>;

        if (req.headers.get(HeaderErrorEnum.OWN_ERROR) === 'true') {
            requestToHandle = req.clone({
                headers: req.headers.delete(HeaderErrorEnum.OWN_ERROR),
            });

            const alreadyRegistered: boolean = this.ownErrorRequests.some(
                (obj: IReqIdentifier) => obj.id === req.url && obj.method === req.method
            );

            if (!alreadyRegistered) {
                this.ownErrorRequests.push({
                    id: req.url,
                    method: req.method,
                });
            }
        } else {
            requestToHandle = req;
        }

        return next.handle(requestToHandle).pipe(
            catchError((error: any) => {
                const isInOwnErrorArr: boolean = this.ownErrorRequests.some(
                    (obj: IReqIdentifier) => obj.id === req.url && obj.method === req.method
                );

                if (error.status === 401) {
                    if (!req.url.includes('sign_out')) {
                        this.modalService.openModal({
                            type: ModalType.STANDARD,
                            body: {
                                title: 'ERRORS.HTTP.401.TITLE',
                                text: 'ERRORS.HTTP.401.BODY',
                            },
                        });
                        setTimeout(() => {
                            this.store.dispatch(new Logout());
                        }, 2000);
                    }
                } else if (isInOwnErrorArr) {
                    if (error?.error?.errors) {
                        const messages: string[] = error.error.errors;

                        if (!messages.includes(undefined)) {
                            return throwError(messages);
                        }

                        this.store.dispatch(new SetError([error]));
                    } else if (error?.error?.error) {
                        const message: string = errorMessageTranslator(error.error.error);
                        if (!message.includes(undefined)) {
                            return throwError(message);
                        }
                        return throwError(error.error.error);
                    } else {
                        const currentError: string = errorCodeTranslator(error.status);
                        if (currentError !== undefined) {
                            return throwError([currentError, error]);
                        }
                        this.store.dispatch(new SetError([error]));
                    }
                } else {
                    this.store.dispatch(new SetError([error]));
                }

                return of(error);
            })
        );
    }
}
